// PurchaseOrderRichTextSection.jsx
//
// Thin PO wrapper around DocumentRichTextSection.

import React from 'react';

import DocumentRichTextSection from 'nodetypes/documents/kit/DocumentRichTextSection';

/**
 * PurchaseOrderRichTextSection
 *
 * @param {object} props
 */
const PurchaseOrderRichTextSection = React.memo((props) => (
  <DocumentRichTextSection {...props} />
));

PurchaseOrderRichTextSection.displayName = 'PurchaseOrderRichTextSection';

export default PurchaseOrderRichTextSection;
